import {DeliveryPointStruct, IataServiceLevelStruct, RefuelerCompanyCodeStruct} from "../../../common/models";
import {Model} from "../../../common/models/base";


export interface ProductServiceStruct {
    id?: number;
    fuel_specification?: string;
    delivery_point_id?: number;
    delivery_point?: DeliveryPointStruct;
    iata_service_level?: IataServiceLevelStruct;
    operating_hours?: string;
    refueler_company_code?: RefuelerCompanyCodeStruct;
    title_transfer?: string;
    comments?: string;

    payment?: string;
    product_pricing?: string;
}

export class ProductService implements ProductServiceStruct {

    constructor(
    ) {

    }

    public static create(data: ProductServiceStruct = {}) {
    }
}
